import React from 'react';
import { Flag, ShieldCheck, AlertTriangle } from 'lucide-react';

const CommunityGuidelines = () => {
  return (
    <div className="container" style={{ paddingTop: '40px', paddingBottom: '60px', maxWidth: '820px' }}>
      <h1 style={{ fontSize: '32px', fontWeight: 700, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <ShieldCheck size={30} /> Community Guidelines
      </h1>
      <p style={{ color: 'var(--textSecondary)', marginBottom: '32px' }}>
        BabyResell is a marketplace for families. To keep it safe and trustworthy,
        every listing must follow these guidelines. Listings that break them may be
        removed and repeat violations can lead to account suspension.
      </p>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>✅ What you can sell</h2>
        <ul style={{ lineHeight: 1.8, color: 'var(--text)', paddingLeft: '20px' }}>
          <li>Clean, safe, pre-loved baby and toddler items</li>
          <li>Clothing, toys, gear, furniture, and accessories in usable condition</li>
          <li>Items you own and are legally allowed to resell</li>
          <li>Listings with accurate photos and honest descriptions</li>
        </ul>
      </section>

      <section style={{ marginBottom: '28px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <AlertTriangle size={20} color="#F59E0B" /> What is NOT allowed
        </h2>
        <ul style={{ lineHeight: 1.8, color: 'var(--text)', paddingLeft: '20px' }}>
          <li><strong>Inappropriate or offensive content</strong> — nudity, sexual content, hateful, violent, or harassing material in photos or text.</li>
          <li><strong>Prohibited or recalled items</strong> — items under safety recall, drop-side cribs, expired car seats, or anything banned by law.</li>
          <li><strong>Counterfeit or fake goods</strong> — knock-offs or items misrepresented as a brand they are not.</li>
          <li><strong>Misleading listings</strong> — inaccurate photos, false condition, or deceptive descriptions/pricing.</li>
          <li><strong>Unsafe or unsanitary items</strong> — used pacifiers, opened formula, breast pump parts that contact milk, or soiled goods.</li>
          <li><strong>Spam or scams</strong> — duplicate listings, off-platform payment schemes, or fraud.</li>
          <li><strong>Prohibited categories</strong> — weapons, medication, recalled electronics, or any illegal goods.</li>
        </ul>
      </section>

      <section style={{
        marginBottom: '28px',
        background: 'var(--cardBackground)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '20px 24px',
      }}>
        <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Flag size={20} /> Reporting a listing
        </h2>
        <p style={{ lineHeight: 1.7, marginBottom: '12px' }}>
          If you see a listing that breaks these guidelines, please report it. On any
          listing page, click <strong>“Report this listing”</strong>, choose a reason,
          and add any helpful details. Reports are anonymous to the seller.
        </p>
        <p style={{ lineHeight: 1.7, margin: 0, color: 'var(--textSecondary)' }}>
          Our team reviews reports daily. When a listing violates these guidelines we
          remove it and notify the seller. Thank you for helping keep BabyResell safe
          for families.
        </p>
      </section>

      <p style={{ color: 'var(--textSecondary)', fontSize: '14px' }}>
        Questions? Visit our <a href="/help" style={{ color: 'var(--primary)' }}>Help Center</a> or{' '}
        <a href="/contact" style={{ color: 'var(--primary)' }}>contact us</a>.
      </p>
    </div>
  );
};

export default CommunityGuidelines;
